import { _global } from '../global';

var manageBookingDialog = {
	initialized: false,
	init: function (el, appStart) {
		if (appStart) {
			return;
		}

		const $el = $(el);
		const $customerSelector = $el.find('[data-control="customer-selector"]');
		const $departmentSelector = $el.find('[data-control="department-selector"]');
		const $employeeSelector = $el.find('[data-control="employee-selector"]');

		// Todo:
		// The initialized prop does not get reset on page reload, but event listners are dropped, so we're checking
		// Against the DOM for now. Look into this, and why the component is being called twice in the first place...
		if ($customerSelector.data('init')) {
			return;
		}
		$customerSelector.data('init', true);
		manageBookingDialog.initialized = true;

		$customerSelector
			.on('change', () => {
				var $selectedOption = $customerSelector.find(':selected');
				if ($selectedOption.attr('value')) {
					$departmentSelector.prop('disabled', 'disabled');
					$employeeSelector.prop('disabled', 'disabled');
				} else {
					$departmentSelector.removeProp('disabled');
					$employeeSelector.removeProp('disabled');
				}
			});
		$departmentSelector
			.on('change', () => {
				var $selectedOption = $departmentSelector.find(':selected');
				if ($selectedOption.attr('value')) {
					$customerSelector.prop('disabled', 'disabled');
					$employeeSelector.prop('disabled', 'disabled');
				} else {
					$customerSelector.removeProp('disabled');
					$employeeSelector.removeProp('disabled');
				}
			});
		$employeeSelector
			.on('change', () => {
				var $selectedOption = $employeeSelector.find(':selected');
				if ($selectedOption.attr('value')) {
					$customerSelector.prop('disabled', 'disabled');
					$departmentSelector.prop('disabled', 'disabled');
				} else {
					$customerSelector.removeProp('disabled');
					$departmentSelector.removeProp('disabled');
				}
			});

		var $selectedCustomer = $customerSelector.find(':selected');
		var $selectedDepartment = $departmentSelector.find(':selected');
		var $selectedEmployee = $employeeSelector.find(':selected');
		if ($selectedCustomer.attr('value')) {
			$departmentSelector.prop('disabled', 'disabled');
			$employeeSelector.prop('disabled', 'disabled');
		}
		else if ($selectedDepartment.attr('value')) {
			$customerSelector.prop('disabled', 'disabled');
			$employeeSelector.prop('disabled', 'disabled');
		}
		else if ($selectedEmployee.attr('value')) {
			$customerSelector.prop('disabled', 'disabled');
			$departmentSelector.prop('disabled', 'disabled');
		}
		const $historyTab = $el.find('[data-control="history-tab-body"]');
		const historyLoadUrl = $historyTab.data('load-url');
		const $historyTabHeader = $el.find('[data-control="history-tab-header"]');
		const $editTabHeader = $el.find('[data-control="edit-tab-header"]');
		const $mainFooter = $el.find('[data-control="main-footer"]');
		const $historyFooter = $el.find('[data-control="history-footer"]');

		let loaded = false;
		$editTabHeader.on('show.bs.tab', e => {
			loaded = false;
			$mainFooter.show();
			$historyFooter.hide();
		});
		$historyTabHeader.on('show.bs.tab', e => {
			if (loaded) {
				return;
			}
			$historyTab.load(historyLoadUrl, function () {
				loaded = true;
				$historyTabHeader.tab('show');
				$mainFooter.hide();
				$historyFooter.show();
			});
			return false;
		});
	},
	teardown: function () {
		const $customerSelector = $('[data-control="customer-selector"]');
		const $departmentSelector = $('[data-control="department-selector"]');
		const $employeeSelector = $('[data-control="employee-selector"]');

		// Remove event listeners
		$customerSelector.off('change');
		$departmentSelector.off('change');
		$employeeSelector.off('change');

		// Reset initialized state
		manageBookingDialog.initialized = false;
		$customerSelector.removeData('init');
	}
};
_global.modules.ManageBookingDialog = manageBookingDialog;
(<any>_global).ManageBookingDialog = manageBookingDialog;
